import {
  Box,
  Grid,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import Button from 'components/Button';
import messages from 'components/ItemInfoCard/messages';
import {
  ReversedStyledGrid,
  StyledCaption,
  StyledCard,
  StyledGrid,
  StyledIcon,
  StyledLongBody,
} from 'components/ItemInfoCard/styles';
import { AMCInfoCardProps, styles } from 'components/ItemInfoCard/types';
import { Captions } from 'components/Typography';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { translate } from 'helpers/intl';
import { pushTo } from 'helpers/routes';
import { AssuranceIcon } from 'images';
import MyContractBackground from 'images/AMC-BG-divider.svg';
import { sanlamDarkBlue, sanlamYellow } from 'Material-UI/colors';
import React from 'react';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import PAGES from 'routes/pages';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { uppercase } from 'utils/string';

const useStyles = makeStyles({
  root: {
    fontSize: '11px !important',
    width: '90px !important',
    borderRadius: '6px',
    color: '#285BC7 !important',
    border: '1px solid #FFFFFF !important',
    '&:hover': {
      color: '#285BC7 !important',
    },
  },
});

const AMCInfoCard = (props: AMCInfoCardProps) => {
  const {
    firstInformationLabel,
    firstInformationValue,
    secondInformationLabel,
    secondInformationValue,
    title,
    wrapperPaddingLeft,
    wrapperPaddingRight,
  } = props;
  const classes = useStyles();
  const styles: styles = {
    icon: 'AMCMainIcon',
    titleColor: sanlamYellow,
    labelsColor: 'rgba(255,255,255,0.87)',
    valuesColor: '#FFF',
    backgroundImage: MyContractBackground,
    buttonRootStyles: classes.root,
  };
  const lang = useSelector(getLocaleSelector);
  const reverse = lang === LANGUAGES.AR;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <StyledCard
      backgroundImage={styles.backgroundImage}
      backgroundColor={styles.backgroundColor}
      paddingLeft={wrapperPaddingLeft}
      paddingRight={wrapperPaddingRight}
    >
      <StyledGrid
        container
        alignItems="center"
        justify="space-between"
        marginBottom="17px"
      >
        <ReversedStyledGrid reverse={reverse} container justify="space-between">
          <Grid>
            <ReversedStyledGrid
              reverse={reverse}
              container
              justify="space-between"
            >
              <Grid>
                {styles.icon && (
                  <StyledGrid textAlign="center" height="30px">
                    <StyledIcon
                      width={matches ? '29px' : '34px'}
                      height={matches ? '29px' : '34px'}
                      src={AssuranceIcon[styles.icon]}
                      alt="item-icon"
                    />
                  </StyledGrid>
                )}
              </Grid>
              <Grid>
                <Box paddingLeft="6px" paddingTop="6px">
                  <StyledLongBody color={styles.titleColor} matches={matches}>
                    {uppercase(title || '')}
                  </StyledLongBody>
                </Box>
              </Grid>
            </ReversedStyledGrid>
          </Grid>
        </ReversedStyledGrid>
      </StyledGrid>
      <Grid container justify="space-between">
        <ReversedStyledGrid reverse={reverse} container justify="space-between">
          <Grid item>
            <StyledCaption
              matches={matches}
              color={styles.labelsColor || '#9797AF'}
              marginBottom="6px"
            >
              {uppercase(firstInformationLabel)}
            </StyledCaption>
          </Grid>
          <Grid item>
            <StyledCaption
              color={styles.valuesColor || sanlamDarkBlue}
              weight="bold"
              marginBottom="6px"
              textAlign="end"
            >
              {firstInformationValue}
            </StyledCaption>
          </Grid>
        </ReversedStyledGrid>
        <ReversedStyledGrid reverse={reverse} container justify="space-between">
          <Grid item>
            <Captions color={styles.labelsColor || '#9797AF'}>
              {uppercase(secondInformationLabel)}
            </Captions>
          </Grid>
          <Grid item>
            <StyledCaption
              color={styles.valuesColor || sanlamDarkBlue}
              weight="bold"
              textAlign="end"
              marginBottom="15px"
            >
              {secondInformationValue}
            </StyledCaption>
          </Grid>
        </ReversedStyledGrid>
        <ReversedStyledGrid reverse={reverse} container justify="space-between">
          <Grid>
            <GaClickHOC
              category={EVENT_CATEGORIES.AMC_ACCUEIL}
              label="Mes Contrats AMC_Voir tous"
            >
              <Button
                variant="outlined"
                className={styles.buttonRootStyles}
                size="small"
                onClick={() => {
                  props.setDetailsPageBreadcrumbsPath([
                    { name: 'amc', route: PAGES.AMC_DASHBOARD },
                    { name: 'adhesion', police: title },
                  ]);
                  pushTo(PAGES.AMC_DETAILS);
                }}
              >
                {translate({ ...messages.voirTous }, props)}
              </Button>
            </GaClickHOC>
          </Grid>
        </ReversedStyledGrid>
      </Grid>
    </StyledCard>
  );
};

export default injectIntl(AMCInfoCard);
